// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type DefaultCardType = {
  children: React.ReactNode;
  // Overrides the default background below, for the rare consumer that
  // wants something else entirely.
  backgroundColor?: string;
};

const DefaultCard = ({ children, backgroundColor }: DefaultCardType) => {
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  // #4D5063 in dark mode, #FFF in light mode -- same treatment every
  // DefaultCard consumer wants, so it's the default rather than something
  // each page has to opt into.
  const defaultBackgroundColor =
    theme.palette.mode === "dark" ? "#4D5063" : "#FFF";

  return (
    <Box
      sx={{
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: backgroundColor ?? defaultBackgroundColor,
        color: onSurface,
        border: "1px solid #5B6D7A40",
        height: "fit-content",
      }}
    >
      {children}
    </Box>
  );
};

export default DefaultCard;
